const BASE_URL = process.env.REACT_APP_SERVER_URL; // servidor en Node.js

// peticiones de aplicación
const request = (endpoint, obj, method = 'GET') => {
    const url = `${BASE_URL}/${endpoint}`;
    if (method === 'GET')
        return fetch(url, { method });
    else
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(obj)
        });
};

export {
    request
};